export default {
  //North Macedonia mk(langugecode) MK(countrycode) Северна Македонија / Македонски
  LandingPage: {
    intro_sub:
      'Дај му втор живот на отпадот од пакувањето и заштити ја животната средина.',
    title: 'Samsung Upcycle-пакување',
    sequence1_1: 'Придружи ни се во намалувањето на отпадот',
    sequence1_2:
      'за одржлива животна средина со пренаменување на пакувањето од твојот производ за изработка на корисни предмети. Движи се надолу за да го направиш првиот чекор.',
    sequence2_1: 'Ви го претставуваме Samsung Upcycle-Packaging',
    sequence2_2:
      'Кутија за производ, дизајнирана специјално да може да се рециклира за да можеш и ти да имаш придонес за животната средина. Направи различни предмети за дома со пакувањето од производ.',
    sequence3_1: 'Следи ги означените точки на пакувањето',
    sequence3_2:
      'Исечи го пакувањето како што е покажано и состави ги деловите за да создадеш одличен предмет.',
    sequence4_1: 'Избери го предметот што сакаш да го направиш',
    sequence4_2:
      'Движи се надолу и избери го моделот на производ што го имаш на пакувањето. Потоа, најди разни опции за дизајн. Сега, започни ја авантурата со предметот што сакаш да го направиш.',
    selectBox: 'Избери го твојот производ',
    moreActivity:
      "За повеќе информации за активностите за одржливост на Samsung",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitors', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
    //   'https://www.samsung.com/mk/sustainability/overview/',
    // moreActivityLink:'https://www.samsung.com/mk/aboutsamsung/sustainability/strategy/',
    moreActivityLink: 'https://www.samsung.com/mk/sustainability/overview/',
    footer: `
    Copyright© 2019-2021 Samsung. Сите права се задржани.`,
  },
  ProductPage: {
    selectDesign: 'Избери дизајн за креирање',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'ТВ конзола',
    StorageBox: 'Кутија за складирање',
    MagazineRack: 'Држач за весници',
    CatHouse: 'Куќичка за мачки',
    CatTunnel: 'Тунел за мачки',
    BookShelf: 'Полица за книги',
    DeskShelf: 'Полица за биро',
    BlackRhino: 'Загрозени \n животни \n Црн носорог', //update
    PolarBear: 'Загрозени \n животни \n Поларна мечка', //update
    SeaTurtle: 'Загрозени \n животни \n Морска желка', //update
    TheRider: 'Јавачот', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Масичка за \n кауч Alex', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko масичка', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Држач за \n разгледници', //update
    SneakerRack: 'Полица за обувки', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Кутија со алат', //update
    DeskStationary: 'Прибор',
    CoinBank: 'Касичка за штедење',
    MobileScanner:'Држач за скенер на смартфон',
    TabletScanner:'Држач за скенер на таблет',
    PetStairs:'Скали за миленичиња',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'минути',
    all:'ALL',
    in: 'во',
    inOnly: 'во само',
    allBoxSize: 'Кутии во сите големини',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'упатства',
    prepare: 'Подготви ја кутијата',
    LetsDesign: "Ајде да дизајнираме",
    drawParts: 'Нацртај делови на кутијата',
    note1: 'Графичката поставеност може да се разликува во зависност од земјата и големината',
    note2: 'Прво скицирај го целиот цртеж да се собере на кутијата',
    numberSpace: 'број = растојание помеѓу точките',
    diagonal: 'дијагонално',
    LEFT: 'ЛЕВ (дел)',
    RIGHT: 'ДЕСЕН (дел)',
    TOP: 'ГОРЕН (дел)',
    TOP1: 'ГОРЕН (дел) 1',
    TOP2: 'ГОРЕН (дел) 2',
    BACK: 'ЗАДЕН (дел)',
    MIDDLE: 'СРЕДЕН (дел)',
    MIDDLE2: 'СРЕДЕН (дел) 2',
    BOTTOM: 'ДОЛЕН (дел)',
    FRONT: 'ПРЕДЕН (дел)',
    SIDE: 'СТРАНА (дел)',
    secondSIDE: 'ВТОРА СТРАНА (дел)',
    secondSIDE1: 'ВТОРА СТРАНА (дел) 1',
    secondSIDE2: 'ВТОРА СТРАНА (дел) 2',
    LEG: 'НОГА (дел)', //update
    JOINT: 'ЗГЛОБ (дел)', //update
    FACE: 'ЛИЦЕ (дел)', //update
    DRAWERBOTTOM: 'ДНО НА ФИОКАТА (дел)', //update
    DRAWERSIDE: 'СТРАНА НА ФИОКАТА (дел)', //update
    NOSE: 'НОС (дел)', //update
    HANDLE: 'РАЧКА (дел)', //update
    BOTTOMSIDE: 'ДОЛНА СТРАНА (дел)', //update
    TOPSIDE: 'ГОРНА СТРАНА (дел)', //update
    WING: 'КРИЛО (дел)', //update
    cutAndAssemble: "Ајде да сечеме и спојуваме",
    beCareful: 'Внимавај да не се повредиш додека сечеш',
    cutOutParts: 'Сечење на деловите',
    assemble: 'Спојување',
    Assemblyguide: 'Водич за спојување', //update
    fold: 'Пример за превиткување',
    foldGuide: 'За да го превиткаш картонот, користи ги рабовите на мебелот',
    foldGuideDezeen:
      'Притисни ја испрекинатата линија на картонот со алат за превиткување неколку пати за да се превитка картонот', //update
    glue: 'Нанеси течен лепак или селотејп рамномерно на површината', //update
    cable: 'За поврзување, користи кабли или жици', //update
    done: 'Готово!',
    goBack: 'Врати се на главното мени',
  },
  CautionPage: {
    CAUTION: 'ПРЕДУПРЕДУВАЊЕ',
    needItem: 'Ќе ти требаат овие предмети',
    children: 'Децата треба да бидат со возрасни',
    mat:
      'Постели нешто на подот за да го заштитиш од гребаници',
    doNotPutHeavyThing:
      'Не згазнувај и не седнувај на овој мебел и не оставај тешки предмети врз него',
    doNotThrow:
      'Не фрлај или удирај со мебелот кон ништо, вклучувајќи луѓе и животни',
    stayAwayFlame: 'Да се чува подалеку од оган',
    stayAwayWater: 'Да не се приближува до вода или влага',
    mayDamaged: '* Кутијата од телевизорот може да се оштети за време на процесот на испорака',
    companyDoestResponsible:
      '* Компанијата нема никаква одговорност за дефекти или повреди за време на оваа работа',
    cannotBeReturned:
      '* Производот со оштетени кутии не може да се врати поради проблеми поврзани со квалитет',
    understand: 'Во ред, разбрав',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Се свртуваме кон екологијата',
      text1:
        'Користиме помалку хартија и мастило за најголем дел од нашите пакувања за телевизори во споредба со нашите претходни пакувања за да ја засилиме нашата заложба за одржливост',
      text2:'',
      text2_special:
        '(* Горенаведеното не се однесува на одредени модели, вклучувајќи ги Lifestyle телевизорите)',
      text3: 'Избери ги копчињата подолу за да откриеш повеќе',
    },
    greenIn: {
      title: 'Се свртуваме кон екологијата со нашите пакувања за телевизори',
      subtitle1: 'Барај информации за производот',
      subtitle2: 'Креативно рециклирање на еко-пакување',
      desc: 'Избери назив на модел за повеќе информации',
      descM: '*Сликај го бројот на моделот на телевизорот',
      guide: 'назив на модел',
      button: 'Сликај',
      button2: 'Продолжи на Направи предмети',
      product_info: 'Информации за производот',
    },
    search: {
      guide: 'Пребарување..',
      noResult: 'Нема резултати',
      more: 'ПОВЕЌЕ',
      search: 'Пребарување',
      retake: 'Сликај одново',
      result: 'Резултат',
    },
    photo: {
      guide1: 'Стави го називот на моделот на телевизорот во кутијата',
      guide2: '(на пр. Q800A, UT7000, RU7100, итн.)',
    },
  },
  searchCountrySelect: 'Избери земја за пребарување'
};
